/* global axios */
import ApiClient from './ApiClient';

class KanbanStagesAPI extends ApiClient {
  constructor() {
    super('kanban_stages', { accountScoped: true });
  }

  reorder(stages) {
    return axios.post(`${this.url}/reorder`, { stages });
  }
}

export default new KanbanStagesAPI();
